"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _es6Symbol = _interopRequireDefault(require("es6-symbol"));

var _constants = require("./constants");

var _utils = require("./_utils");

/**
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2018 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Inc. and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe Inc.
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Inc.
 */
var singleton = (0, _es6Symbol["default"])();
var singletonEnforcer = (0, _es6Symbol["default"])();
/**
 * A singleton Client class is used for communicating with the Invitation Service.
 */

var Client = /*#__PURE__*/function () {
  /**
   * Constructor for Client.
   * @access private
   * @param {Symbol} enforcer used to ensure we have a singleton
   */
  function Client(enforcer) {
    (0, _classCallCheck2["default"])(this, Client);
    this._token = null;
    this._environment = 'stage';
    this._apiKey = null;

    if (enforcer !== singletonEnforcer && enforcer !== 'test') {
      throw new Error('Cannot create singleton');
    }
  }
  /**
   * Get the single instance of the Client class.
   * @access private
   * @return {Object} The single instance of the Client class.
   */


  (0, _createClass2["default"])(Client, [{
    key: "configure",

    /**
     * Configure the Invitation Service Access Layer.
     * @param {object} settings -
     *    settings.token : The user's authorization token.
     *    settings.environment : The environment (stage, prod).
     *    settings.apiKey : The api key
     * @example <caption>Configuring the Client</caption>
     * Client.instance.configure({
     *   token: 'Bearer <token>',
     *   environment: 'stage',
     *   apiKey: '<apiKey>'
     * });
     * @returns {undefined}
     */
    value: function configure(settings) {
      if (settings.token) {
        this._token = settings.token;
      }

      if (settings.environment) {
        this._environment = settings.environment;
        this._endpoint = (0, _constants.getConfigValue)(this._environment, 'INVITATIONS_SERVICE_ENDPOINT');
      }

      if (settings.apiKey) {
        this._apiKey = settings.apiKey;
      }
    }
    /**
     * Set the authorization token
     * @param {string} token - The new token.
     * @example <caption>Setting the token</caption>
     * Client.instance.token = 'Bearer <token>';
     */

  }, {
    key: "fetch",

    /**
     * Fetch from Invitation services
     * @access private
     *   @param {Object} options
     *   @param {String} options.type - A unique type to identify the call.
     *   @param {string} options.urlPath - The url path to the API (not including the <domain name>/api/v2/)
     *   @param {string} options.method - GET, POST, PUT, UPDATE, or DELETE.
     *   @param {Object} options.body - The body object.
     *   @param {Object} options.headers - The request headers.
     *   @param {Boolean} options.returnRaw - boolean whether to return the raw response to the client or not
     * @return {Promise} A promise that calls a given url
     */
    value: function fetch() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var body = options.body,
          headers = options.headers,
          method = options.method,
          returnRaw = options.returnRaw,
          type = options.type,
          urlPath = options.urlPath; // Check if we have a token

      if (!this._token) {
        throw new Error('Authorization not configured. Please set the bearer token before calling this method.');
      }

      if (!this._apiKey) {
        throw new Error('API key not configured. Please set apiKey before calling this method.');
      } // Setup the default headers


      var _headers = {
        'Content-Type': 'application/json',
        'X-API-Key': this._apiKey,
        'Authorization': this._token.indexOf('Bearer ') > -1 ? this._token : "Bearer ".concat(this._token),
        'If-Modified-Since': Date.now()
      }; // Setup the method (or default)

      var curMethod = options.method || 'GET';

      var checkStatus = function checkStatus(response) {
        // For getCapabilities call, we don't return an error.
        // For the rest, we check the status.
        if (returnRaw || type === 'invitations.create' || response.status >= 200 && response.status < 304) {
          return response;
        } else {
          var error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      };

      var parseJSON = function parseJSON(response) {
        if (returnRaw) {
          return response;
        }

        return new Promise(function (resolve, reject) {
          // If there are cases when headers needs to be returned, this is the place to extract/resolve it.
          if (method === 'DELETE' || method === 'HEAD') {
            // No body in response to parse for
            return resolve(response); // Return the json part
          } else {
            response.json().then(function (data) {
              resolve(data);
            });
          }
        });
      }; // If the urlPath contains the endpoint, only use the endpoint. This is useful for following the
      // _links.next.href for pagination.


      var fetchUrl = urlPath.startsWith(this._endpoint) ? urlPath : this._endpoint + urlPath;
      return (0, _isomorphicFetch["default"])(fetchUrl, {
        method: curMethod,
        headers: _headers,
        body: body ? JSON.stringify(body) : undefined
      }).then(checkStatus).then(parseJSON);
    }
    /**
     * fetchRaw - fetch method for non-invitation end points
     * @param  {String} [url=''] - request url that fetch will use.
     * @param  {String} [method='POST'] - the menthod to use.
     * @return {Object} - fetch results after responseHandler results
     */

  }, {
    key: "fetchRaw",
    value: function fetchRaw() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'POST';
      var headers = {
        accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8',
        'content-type': 'application/x-www-form-urlencoded;multipart/form-data;text/plain',
        'Authorization': this._token.indexOf('Bearer ') > -1 ? this._token : "Bearer ".concat(this._token)
      };
      var params = {
        headers: headers,
        method: method
      };
      return (0, _isomorphicFetch["default"])(url, headers).then(_utils.responseHandler);
    }
  }, {
    key: "token",
    set: function set(token) {
      this._token = token;
    }
    /**
     * Get the token
     * @return {string} The current token
     * @example <caption>Get the token</caption>
     * let token = Client.instance.token;
     */
    ,
    get: function get() {
      return this._token;
    }
    /**
     * Set the api key
     * @param {string} apiKey - The new key.
     */

  }, {
    key: "apiKey",
    set: function set(apiKey) {
      this._apiKey = apiKey;
    }
    /**
     * Get the api key
     * @return {string} The current api key
     * @example <caption>Get the api key</caption>
     * let apiKey = Client.instance.apiKey;
     */
    ,
    get: function get() {
      return this._apiKey;
    }
  }, {
    key: "endpoint",
    get: function get() {
      return this._endpoint;
    }
    /**
     * Set the environment.
     * @param {string} environment - The new environment
     * @example <caption>Setting the environment</caption>
     * Client.instance.environment = 'stage';
     */

  }, {
    key: "environment",
    set: function set(environment) {
      var acceptedEnvironments = ['stage', 'prod'];
      var acceptedEnvironmentsString = ''; // Create the string based on acceptedEnvironments.

      acceptedEnvironments.forEach(function (acceptedEnvironment, index) {
        var endString = index + 1 === acceptedEnvironments.length ? '' : ', ';
        acceptedEnvironmentsString += acceptedEnvironment + endString;
      }); // If the value specified is not accepted, throw an error.

      if (acceptedEnvironments.indexOf(environment) === -1) {
        throw new Error("Setting the environment to ".concat(environment, " is not accepted. Acceptable values are ").concat(acceptedEnvironmentsString));
      } // Set the environment variable


      this._environment = environment;
      this._endpoint = (0, _constants.getConfigValue)(this._environment, 'INVITATIONS_SERVICE_ENDPOINT');
    }
    /**
     * Get the environment
     * @return {string} The current environment
     * @example <caption>Get the environment</caption>
     * let environment = Client.instance.environment;
     */
    ,
    get: function get() {
      return this._environment;
    }
  }], [{
    key: "instance",
    get: function get() {
      if (!this[singleton]) {
        this[singleton] = new Client(singletonEnforcer);
      }

      return this[singleton];
    }
  }]);
  return Client;
}();
/**
 * Exports the Client class.
 */


var _default = Client;
exports["default"] = _default;